// TSS vite/04 §"Endpoint paths".
// No leading slash — axios joins baseURL + url with a single slash.
//
// There is no `admin/reviews` collection: a review is a verdict on a task, so
// it hangs off the task.
//
// THE DECISION IS `review-round/decision`, citing the round that was read.
// `POST admin/tasks/{id}/review` is retired in Core and answers 410 on every
// call (C02): it decided without citing a round, which let a person approve an
// unversioned delivery.
export const reviewPaths = {
    waiting:  () => 'admin/tasks',
    rounds:   (id) => `admin/tasks/${id}/review-rounds`,
    decision: (id) => `admin/tasks/${id}/review-round/decision`,
    // The agent's progress notes. `events:read`, which not every reviewer holds.
    events:   () => 'admin/events',
};
